import React from "react";
import { Skeleton, Box } from "@mui/material";

function PhotoGallerySkeleton() {
    const skeletonStyle = {
        backgroundColor: 'rgba(0, 0, 0, 0.12)',
        borderRadius: '2px'
    };

    return (
        <Box sx={{ padding: "24px" }}>
            <Box sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "20px 10px",
                marginBottom: "16px"
            }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: "5%" }}>
                    <Skeleton
                        variant="rectangular"
                        width={50}
                        height={50}
                        sx={skeletonStyle}
                    />
                    <Skeleton
                        variant="text"
                        sx={{
                            ...skeletonStyle,
                            width: { xs: 200, sm: 300, md: 400 },
                            height: { xs: 60, sm: 70, md: 80 }
                        }}
                    />
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <Skeleton
                        variant="rectangular"
                        width={50}
                        height={40}
                        sx={skeletonStyle}
                    />
                    <Skeleton
                        variant="text"
                        sx={{
                            ...skeletonStyle,
                            width: { xs: 60, sm: 80, md: 100 },
                            height: { xs: 60, sm: 70, md: 80 }
                        }}
                    />
                </Box>
            </Box>

            <Box sx={{
                display: "grid",
                gridTemplateColumns: {
                    xs: "1fr",
                    sm: "repeat(2, 1fr)",
                    md: "repeat(4, 1fr)"
                },
                gap: "8px"
            }}>
                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Skeleton variant="rectangular" width="100%" height={250} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={180} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={300} sx={skeletonStyle} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Skeleton variant="rectangular" width="100%" height={200} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={280} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={220} sx={skeletonStyle} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Skeleton variant="rectangular" width="100%" height={280} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={190} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={260} sx={skeletonStyle} />
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: "8px" }}>
                    <Skeleton variant="rectangular" width="100%" height={210} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={270} sx={skeletonStyle} />
                    <Skeleton variant="rectangular" width="100%" height={230} sx={skeletonStyle} />
                </Box>
            </Box>
        </Box>
    );
}

export default PhotoGallerySkeleton;